import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import { formatMoney } from '../../util/currency';

import css from './LtPlusPerksBox.module.css';

const LtPlusPerksBox = ({ protectionCost, intl }) => {
  const formattedProtectionCost = formatMoney(intl, protectionCost);

  return (
    <div className={css.root}>
      <div className={css.heading}>
        <FormattedMessage
          id="FieldGuestLiabilityProtection.ltPlusPerkLiabilityProtectionApplied"
          values={{
            amount: formattedProtectionCost,
          }}
        />
      </div>
      <div className={css.subheading}>
        <FormattedMessage id="FieldGuestLiabilityProtection.ltPlusOtherPerksHeading" />
      </div>
      <ul className={css.list}>
        <li className={css.listItem}>
          <span className={css.checkmark} aria-hidden>
            ✓
          </span>
          <FormattedMessage id="FieldGuestLiabilityProtection.ltPlusPerkEarlyAccess" />
        </li>
        <li className={css.listItem}>
          <span className={css.checkmark} aria-hidden>
            ✓
          </span>
          <FormattedMessage id="FieldGuestLiabilityProtection.ltPlusPerkSweepstakes" />
        </li>
        <li className={css.listItem}>
          <span className={css.checkmark} aria-hidden>
            ✓
          </span>
          <FormattedMessage id="FieldGuestLiabilityProtection.ltPlusPerkDrawProtection" />
        </li>
        <li className={css.listItem}>
          <span className={css.checkmark} aria-hidden>
            ✓
          </span>
          <FormattedMessage id="FieldGuestLiabilityProtection.ltPlusPerkBuckAi" />
        </li>
      </ul>
    </div>
  );
};

LtPlusPerksBox.propTypes = {
  protectionCost: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
};

export default LtPlusPerksBox;
